import { render, staticRenderFns } from "./WhiteList.vue?vue&type=template&id=60757fc2&"
import script from "./WhiteList.vue?vue&type=script&lang=js&"
export * from "./WhiteList.vue?vue&type=script&lang=js&"
import style0 from "./WhiteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WhiteList.vue"
export default component.exports